module.exports = __webpack_public_path__ + "static/img/qianyiyichang2x.3088a0fa.png";